import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { getFurtherPageWithStatus } from '../../assets/js/route-utils';
import DADOS_SIM from '../../consts/consts';
import ENUM from '../../consts/enum';
import HISTORICO_ACESSO_FIELDS from '../../consts/historico-acesso-fields';
import ROUTES_NAME from '../../consts/routes-name';
import SessionService from '../../session/session-service';
import ModalConfirmaCancelaItem from '../ModalConfirmaCancelaItem';
import { ModalTipoSimulacaoContext } from '../ModalTipoSimulacao';
import ModalNovaSimulacao from './../../containers/ModalNovaSimulacao/index';
import styles from './styles.module.scss';

const cotacaoValues = DADOS_SIM.DADOS_COTACAO;
class AppHeader extends Component {
    state = { isModalOpen: false, showHasSimModal: false, checkedForNewSim: false };
    currPath = null;

    get dadosCotacao() {
        return SessionService.getSession();
    }

    componentDidMount() {
        this.currPath = this.props.location.pathname;
    }

    componentDidUpdate() {
        if (this.currPath === ROUTES_NAME.HOME || this.currPath === '/') {
            if (this.context && this.context.checkedForBroto && !this.state.checkedForNewSim) {
                const chaveBroto = SessionService.getChaveBroto();
                const hasSim = this.checkIfHasSimulation(chaveBroto);
                this.setState({ showHasSimModal: hasSim, checkedForNewSim: true });
            }
        } else if (!this.state.checkedForNewSim) this.setState({ showHasSimModal: false, checkedForNewSim: true });
    }

    checkIfHasSimulation(chaveBroto) {
        const session = SessionService.getSession();
        if (
            session &&
            session[cotacaoValues.STATUS_COTACAO] !== ENUM.STATUS_COTACAO.PROPOSTA_FINALIZADA &&
            session[cotacaoValues.CODIGO_COTACAO] &&
            !chaveBroto
        ) {
            return true;
        } else {
            return false;
        }
    }

    handlerCloseModal = () => {
        if (this.state.isModalOpen) this.setState({ isModalOpen: false });
    };

    handlerOpenModal = () => {
        if (this.dadosCotacao && this.dadosCotacao.codigoAcesso) {
            this.setState({ isModalOpen: true });
        } else {
            if (this.newSimAction) {
                this.newSimAction();
            }
            if (this.context) {
                this.context.setVisible(true);
            }
        }
    };

    onLogoClick = () => {
        const statusCotacao = this.dadosCotacao && this.dadosCotacao[cotacaoValues.STATUS_COTACAO];
        if (statusCotacao === ENUM.STATUS_COTACAO.PROPOSTA_FINALIZADA) {
            if (this.newSimAction) this.newSimAction();
        }
    };

    pushFurther = () => {
        this.setState({ showHasSimModal: false });
        const statusCotacao = this.dadosCotacao && this.dadosCotacao[cotacaoValues.STATUS_COTACAO];
        const codigoCotacao = this.dadosCotacao && this.dadosCotacao[cotacaoValues.CODIGO_COTACAO];
        this.props.history.push({
            pathname: getFurtherPageWithStatus(statusCotacao, codigoCotacao),
            redirect: true
        });
    };

    handleCloseModalHasSim = () => {
        if (this.newSimAction) this.newSimAction();
        this.setState({ showHasSimModal: false });
    };

    render() {
        const { isModalOpen, showHasSimModal } = this.state;
        const { historicoAcessoState } = this.props;
        return (
            <div className={styles.divAppHeader}>
                <Link to='/'>
                    <img
                        className={styles.logoBB}
                        src={require('../../assets/img/LogoBB.svg')}
                        alt='Logo BB'
                        onClick={() => this.onLogoClick()}
                    />
                </Link>

                <div className={styles.divOpcaoHeader}>
                    <div className={styles.opcaoHeader} onClick={() => this.handlerOpenModal()}>
                        <Icon name='plus' />
                        <span>Nova simulação</span>
                    </div>

                    {historicoAcessoState && historicoAcessoState[HISTORICO_ACESSO_FIELDS.VISUALIZAR_HISTORICO] && (
                        <div style={{ marginLeft: 30 }}>
                            <Link to={ROUTES_NAME.HISTORICO}>
                                <div className={styles.opcaoHeader}>
                                    <Icon name='search' />
                                    <span>Histórico</span>
                                </div>
                            </Link>
                        </div>
                    )}
                </div>
                <ModalNovaSimulacao
                    open={isModalOpen}
                    handlerCloseModal={this.handlerCloseModal}
                    newSimAction={(action) => (this.newSimAction = action)}
                />
                <ModalConfirmaCancelaItem
                    showModalItem={showHasSimModal}
                    handlerCloseModalItem={this.handleCloseModalHasSim}
                    handlerClickSim={this.pushFurther}
                    tituloModal='Aviso!'
                    mensagem={'Existe uma simulação em andamento, deseja continuar de onde parou?'}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    historicoAcessoState: state.historicoAcessoReducer
});

AppHeader.contextType = ModalTipoSimulacaoContext;

export default connect(mapStateToProps)(withRouter(AppHeader));
